import { PaymentMethod } from "@/graphql/codegen/graphql"

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.Wire]: "Wire [ETF]",
  [PaymentMethod.Check]: "Check",
  [PaymentMethod.Cash]: "Cash",
  [PaymentMethod.CreditCard]: "Credit Card",
  [PaymentMethod.Ach]: "ACH",
}

export const getPaymentMethodLabel = (method: PaymentMethod | string): string => {
  return paymentMethodLabels[method as PaymentMethod] || method
}
